export default __webpack_public_path__ + "static/DavidMericle-6588034dcb4be66db14c6d00559da902.jpg";